"use client";
import { useState } from "react";
import { useRouter, usePathname } from "next/navigation";

export default function CountrySelector({
  onCountryChange,
  initialCountry = "India",
  title,
  updateUrl = true,
}) {
  const [selectedCountry, setSelectedCountry] = useState(
    initialCountry?.toLowerCase().replace(/\s+/g, "-")
  );
  const router = useRouter();
  const pathname = usePathname();

  const handleCountryChange = (e) => {
    const newCountry = e.target.value;
    setSelectedCountry(newCountry);
    onCountryChange(newCountry);

    // Only update URL on detail pages (e.g. /packages/[slug]/[country]).
    // Prevents invalid routes like /packages/india from list pages.
    const pathDepth = pathname.split("/").filter(Boolean).length;
    if (!updateUrl || pathDepth < 2) {
      return;
    }

    const countryCode = newCountry.toLowerCase().replace(/\s+/g, "-");
    const pathSegments = pathname.split("/");

    // Check if the URL contains a country parameter (assuming it's the last segment)
    const countries = [
      "uk",
      "india",
      "thailand",
      "turkey",
      "usa",
      "uae",
      "south-korea",
      "malaysia",
      "germaney",
    ];

    if (
      countries.includes(pathSegments[pathSegments.length - 1].toLowerCase())
    ) {
      // If URL has a country parameter, replace it
      pathSegments[pathSegments.length - 1] = countryCode;
      router.push(pathSegments.join("/"));
    } else {
      // If URL doesn't have a country parameter, append it
      router.push(`${pathname}/${countryCode}`);
    }
  };

  return (
    <div className="mb-8 flex flex-col md:flex-row items-center justify-center gap-4 py-6 px-4 bg-[#F1FFFA] rounded-t-[20px] md:rounded-t-[20px] rounded-br-none rounded-bl-none shadow-sm w-full">
      <label className="text-[#0EBE7F] text-lg font-medium text-center md:text-left">
        {title || "Select Country for Treatment Details"}
      </label>
      <select
        value={selectedCountry}
        onChange={handleCountryChange}
        className="px-6 py-3 rounded-xl border border-gray-200 bg-white text-gray-800 min-w-[250px] focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent appearance-none cursor-pointer transition-all duration-200 hover:border-blue-400"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%236B7280'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M19 9l-7 7-7-7'%3E%3C/path%3E%3C/svg%3E")`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "right 1.5rem center",
          backgroundSize: "1.5em 1.5em",
          paddingRight: "3rem",
        }}
      >
        <option value="india">India</option>
        <option value="thailand">Thailand</option>
        <option value="turkey">Turkey</option>
        <option value="usa">USA</option>
        <option value="uae">UAE</option>
        <option value="south-korea">South Korea</option>
        <option value="malaysia">Malaysia</option>
        <option value="germaney">Germaney</option>
        <option value="uk">UK</option>
      </select>
    </div>
  );
}
